module.exports = {
          srcSet: __webpack_public_path__ + "b288f09c292d01029418894c724323e0-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "b288f09c292d01029418894c724323e0-1920.png",width: 1920,height: 510}],
          src: __webpack_public_path__ + "b288f09c292d01029418894c724323e0-1920.png",
          toString:function(){return __webpack_public_path__ + "b288f09c292d01029418894c724323e0-1920.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAc0lEQVR4nGP4//8/Awxf2X2Bsc+jk2FyxASeRWEpwecjgsVX/2dgKP7PwABTxPjj81+GLZ5VzDOlghlmypdGzjeL2nhAp85lgmY022zjLLhChr9//zG+nLyDYQuDD8N6zgaBe0xNCkd0osXrApOZi5KCGQAyBDoSM8SAvwAAAABJRU5ErkJggg==",
          width: 1920,
          height: 510
        }